// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  padding: 0.5rem 1rem;
  pointer-events: none;
}

footer span {
  z-index: 100;
}

.clickable {
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/app/views/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ","sourcesContent":["footer {\n    padding: 0.5rem 1rem ;\n    pointer-events: none;\n}\n\nfooter span {\n    z-index: 100;\n}\n\n.clickable {\n    pointer-events: all;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
